import { render, staticRenderFns } from "./chetouDetail.vue?vue&type=template&id=ea6c878a&scoped=true&"
import script from "./chetouDetail.vue?vue&type=script&lang=js&"
export * from "./chetouDetail.vue?vue&type=script&lang=js&"
import style0 from "./chetouDetail.vue?vue&type=style&index=0&id=ea6c878a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea6c878a",
  null
  
)

export default component.exports